export const getRandomArbitrary = (min: number, max: number) => {
  const minCeiled = Math.ceil(min)
  const maxFloored = Math.floor(max)
  return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled)
}

export const getFormattedCardNumber = (cardNumber: string) => {
  return cardNumber ? cardNumber.toString().replace(/\B(?=(\d{4})+(?!\d))/g, "-") : "-"
}
